import { useEffect, useContext } from "react";
import Context from "../../storage/context";
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.02 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const MapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IgIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="url(#ig-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <defs>
      <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f09433" />
        <stop offset="25%" stopColor="#e6683c" />
        <stop offset="50%" stopColor="#dc2743" />
        <stop offset="75%" stopColor="#cc2366" />
        <stop offset="100%" stopColor="#bc1888" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="#e6683c" stroke="none" />
  </svg>
);

const FbIcon = () => (
  <svg viewBox="0 0 24 24" fill="#1877f2" stroke="none">
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.932-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
  </svg>
);



export default function ContactSection() {




  return (
    <>
      <section className="ct-section">
        <div className="ct-inner">

          {/* header */}
          <div className="ct-header">
            <div className="ct-tag">צרו קשר</div>
            <h2 className="ct-title">אנחנו כאן בשבילך</h2>
            <p className="ct-sub">מוזמנים לפנות אלינו בכל שאלה או בקשה</p>
          </div>

          {/* row 1 — phone + email */}
          <div className="ct-grid">
            <a className="ct-card" href="tel:050-7667702">
              <div className="ct-card__ico"><PhoneIcon /></div>
              <div className="ct-card__body">
                <div className="ct-card__label">טלפון</div>
                <div className="ct-card__value">050-766-7702</div>
                <div className="ct-hours">
                  <span className="ct-hours__dot" />
                  זמינים א׳–ה׳  9:00–19:00
                </div>
              </div>
              <div className="ct-card__arrow">←</div>
            </a>

            <a className="ct-card" href="mailto:info@roeicar.co.il">
              <div className="ct-card__ico"><MailIcon /></div>
              <div className="ct-card__body">
                <div className="ct-card__label">אימייל</div>
                <div className="ct-card__value ct-card__value--sm">hilaben3112@gmail.com</div>
                <div className="ct-card__hint">מענה תוך 24 שעות</div>
              </div>
              <div className="ct-card__arrow">←</div>
            </a>
          </div>

          {/* row 2 — address + ig + fb */}
          <div className="ct-grid--bottom">
            <a className="ct-card" href="https://www.google.com/maps/place/Ge'ula+St+19,+Haifa/@32.8029487,34.9971961,17z/data=!3m1!4b1!4m6!3m5!1s0x151dba53e7058d45:0x3958bebb28fefde8!8m2!3d32.8029442!4d34.999771!16s%2Fg%2F11h59qv6k7?entry=ttu&g_ep=EgoyMDI2MDIyMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
              <div className="ct-card__ico"><MapIcon /></div>
              <div className="ct-card__body">
                <div className="ct-card__label">כתובת</div>
                <div className="ct-card__value ct-card__value--sm">רחוב גאולה 19, חיפה, ישראל</div>
                <div className="ct-card__hint">לחץ לניווט</div>
              </div>
              <div className="ct-card__arrow">←</div>
            </a>


            <a className="ct-card ct-card--ig" href="https://www.instagram.com/roei_car/" target="_blank" rel="noreferrer">
              <div className="ct-card__ico"><IgIcon /></div>
              <div className="ct-card__body">
                <div className="ct-card__label">אינסטגרם</div>
                <div className="ct-card__value ct-card__value--sm">@roeicar</div>
                <div className="ct-card__hint">עקבו אחרינו</div>
              </div>
              <div className="ct-card__arrow">←</div>
            </a>

            <a className="ct-card ct-card--fb" href="https://www.facebook.com/Roeihila/?locale=he_IL" target="_blank" rel="noreferrer">
              <div className="ct-card__ico"><FbIcon /></div>
              <div className="ct-card__body">
                <div className="ct-card__label">פייסבוק</div>
                <div className="ct-card__value ct-card__value--sm">Roei Car</div>
                <div className="ct-card__hint">לייקו את הדף שלנו</div>
              </div>
              <div className="ct-card__arrow">←</div>
            </a>
          </div>

        </div>
      </section>
    </>
  );
}
